import { render } from "./resolution-power.vue?vue&type=template&id=e2da5ba6&scoped=true"
import script from "./resolution-power.vue?vue&type=script&lang=js"
export * from "./resolution-power.vue?vue&type=script&lang=js"

import "./resolution-power.vue?vue&type=style&index=0&id=e2da5ba6&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2da5ba6"]])

export default __exports__